import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Send(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Send", children: [
    /* @__PURE__ */ jsx("path", { d: "M6 19.2505 28.7361 42 42 6 6 19.2505Z", fill: theme.vars.palette.secondary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17.6147 41.0896c-.1896-.0009-.3768-.042-.5493-.1206-.229-.1028-.4245-.2678-.5642-.4762-.1398-.2085-.2182-.452-.2263-.7028l-.2545-9.1239c-.0065-.1831.0247-.3655.0915-.536.0668-.1705.1679-.3255.297-.4555l17.0555-17.0688c.1258-.1258.2751-.2256.4395-.2937.1643-.0681.3405-.1031.5184-.1031.1779 0 .3541.035.5184.1031.1644.0681.3138.1679.4396.2937.1258.1258.2255.2751.2936.4395.0681.1644.1031.3405.1031.5184 0 .1779-.035.3541-.1031.5185-.0681.1643-.1678.3137-.2936.4395l-16.667 16.6401.1608 5.8013 2.6796-2.1839 1.8623 1.9427h-.0938l-4.85 4.0193c-.2354.2143-.5394.3378-.8575.3484Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Send.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Send"
};
validateTidalLicense();
export {
  Send
};
//# sourceMappingURL=Send.js.map
